import { Injectable } from '@angular/core';
import { API, environment } from '@core/envs';
import { HttpClient } from '@angular/common/http';
import { ResponseModel } from '../../models/response/response.model';
import { HTTP_CODE, StorageKeys } from '@core/enums';
import { CountryRulesV2 } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private http: HttpClient
  ) { }


  // ----------------- Rules --------------------
  getRulesByCountry(country: string) {
    const api = environment.getRoute(API.transformation);
    const url = `${api}/countries/${country}/rules`;
    this.http.get<ResponseModel<CountryRulesV2>>(url).subscribe(data => {
      if (data.httpCode === HTTP_CODE.OK && data.response) {
        this.setCountryRules(data.response);
      }
    });
  }

  // getRulesByCountryBff(country: string) {
  //   const url = `${environment.osbBff}/countries/${country}/rules`;
  //   this.http.get<ResponseModel<CountryRules>>(url, { headers: this.authService.getHeadersForBff() }).subscribe(data => {
  //     if (data.httpCode === httpCode.OK && data.response) {
  //       this.setCountryRules(data.response);
  //     }
  //   });
  // }

  // getRulesByCountryV2(country: string) {
  //   const api = environment.getRoute(API.transformation);
  //   const url = `${api}/countries/${country}/rules`;
  //   this.http.get<ResponseModel<CountryRules>>(url).subscribe(data => {
  //     if (data.httpCode === httpCode.OK && data.response) {
  //       this.setCountryRulesNonAuth(data.response);
  //     }

  //     if (data.httpCode === httpCode.UNAUTHORIZED) {
  //       this.notificationService.add({
  //         text: `Erro ${data} - ${this.translate.instant('error.401')}`,
  //         severity: 'Error',
  //         timeout: 20000,
  //       });
  //       localStorage.clear();
  //       sessionStorage.clear();
  //     }

  //   });
  // }

  setCountryRules(rules: CountryRulesV2) {
    sessionStorage.setItem(StorageKeys.COUNTRY_RULES, JSON.stringify(rules));
  }

  getCountryRules(): CountryRulesV2 {
    return JSON.parse(sessionStorage.getItem(StorageKeys.COUNTRY_RULES) as string);
  }
}
